var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fixed-banner", { attrs: { type: "info" } }, [
    _vm._v(
      "\n  " + _vm._s(_vm.$t("settings.themeTab.youreInPreviewMode")) + ".\n  "
    ),
    _c("span", [
      _c(
        "a",
        {
          staticClass: "text-white preview-out clickable bold",
          on: { click: _vm.handleToggleOffPreview },
        },
        [_vm._v(_vm._s(_vm.$t("settings.themeTab.toggleITOff")))]
      ),
    ]),
    _vm._v(" "),
    _c("span", [
      _vm._v("\n    " + _vm._s(_vm.$t("global.words.or")) + "\n    "),
      _c(
        "a",
        {
          staticClass: "text-white save-theme clickable bold",
          on: { click: _vm.handleSaveTheme },
        },
        [_vm._v(_vm._s(_vm.$t("global.actions.saveChanges")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }